<template>
  <div>
    <vue-editor
      useCustomImageHandler
      :editor-toolbar="customToolbar"
      @image-added="handleImageAdded"
      class="editor-container mt-1"
      v-on="$listeners"
      v-bind="$attrs"
    >
    </vue-editor>
    <div v-if="isLoading" class="overlay">
      <v-progress-circular
        indeterminate
        color="secondary"
        size="64"
        width="7"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import { ENDPOINTS } from "../../services/Endpoints";
export default {
  name: "Editor",
  components: {
    VueEditor,
  },
  props: {
    customToolbar: {
      type: Array,
      default: function () {
        return [
          ["image", "video"],
          [
            {
              header: [false, 1, 2, 3, 4, 5, 6],
            },
          ],
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link"],
          [
            {
              align: "",
            },
            {
              align: "center",
            },
            {
              align: "right",
            },
            {
              align: "justify",
            },
          ],
          [
            {
              list: "ordered",
            },
            {
              list: "bullet",
            },
          ],
          [
            {
              indent: "-1",
            },
            {
              indent: "+1",
            },
          ], // outdent/indent
          // ["blockquote"],
          ["clean"],
        ];
      },
    },
  },
  data() {
    return {
      editorContent: "",
      ENDPOINTS,
      isLoading: false,
      // customToolbar: [
      //   ["image", "video"],
      //   [
      //     {
      //       header: [false, 1, 2, 3, 4, 5, 6],
      //     },
      //   ],
      //   ["bold", "italic", "underline", "strike"], // toggled buttons
      //   ["link"],
      //   [
      //     {
      //       align: "",
      //     },
      //     {
      //       align: "center",
      //     },
      //     {
      //       align: "right",
      //     },
      //     {
      //       align: "justify",
      //     },
      //   ],
      //   [
      //     {
      //       list: "ordered",
      //     },
      //     {
      //       list: "bullet",
      //     },
      //   ],
      //   [
      //     {
      //       indent: "-1",
      //     },
      //     {
      //       indent: "+1",
      //     },
      //   ], // outdent/indent
      //   // ["blockquote"],
      //   ["clean"], // remove formatting button
      // ],
    };
  },
  computed: {
    ...mapGetters(["storeSequencial"]),
  },
  methods: {
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
          resolve(event.target.result);
        };

        reader.onerror = event => {
          reject(event.target.error);
        };

        reader.readAsDataURL(file);
      });
    },

    async handleImageAdded(file, Editor, cursorLocation) {
      this.isLoading = true;
      const base64String = await this.readFileAsBase64(file);
      await this.$axios
        .post(this.ENDPOINTS.UPLOAD_IMAGEM_DESCRICAO_PRODUTO, {
          img_base64: base64String,
          loja: this.storeSequencial,
          idproduto: null,
        })
        .then(result => {
          let url = result.url;
          Editor.insertEmbed(cursorLocation, "image", url);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.editor-container {
  background-color: #fff;
  border-radius: 30px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
